import { Skeleton, Stack } from "@skailer-com/uikit";

export function ImportDataEditStepMatchSkeleton() {
  return (
    <Stack gap={"sm"}>
      <Stack className={"card-panel"} gap={"2xl"}>
        <Stack gap={"sm"}>
          <Skeleton className={"w-48 h-7"} />
          <Skeleton className={"w-72 h-5"} />
        </Stack>
        <Stack gap={"sm"}>
          <Skeleton className={"w-40 h-5"} />
          <Skeleton className={"w-40 h-4"} />
          <Skeleton className={"w-100 h-14"} />
        </Stack>
      </Stack>

      {[1, 2].map((i) => (
        <Stack className={"card-panel"} gap={"2xl"} key={`skeleton-${i}`}>
          <Stack direction={"horizontal"} gap={"sm"} justify={"between"}>
            <Stack gap={"sm"}>
              <Skeleton className={"w-40 h-5"} />
              <Skeleton className={"w-40 h-4"} />
            </Stack>
            <Skeleton className={"w-10 h-6"} />
          </Stack>
          <Stack gap={"md"}>
            <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
              <Skeleton className={"w-13 h-4"} />
              <Skeleton className={"w-15 h-7"} />
              <Skeleton className={"w-5 h-4"} />
              <Skeleton className={"w-12 h-7"} />
            </Stack>
            <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
              <Skeleton className={"w-13 h-4"} />
              <Skeleton className={"w-15 h-7"} />
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
